module.exports = __webpack_public_path__ + "img/French Guiana.e2188128.png";